<template>
    <div class="wechat-template-page">
        <el-card shadow="always">
            <div slot="header" class="card-header">
                <div class="card-header-left">
                    <i class="el-icon-set-up"></i>
                    <span>微信模板消息管理</span>
                </div>
                <div class="card-header-right">
                    <el-button type="success" icon="el-icon-refresh" @click="handleSync" :loading="syncLoading">同步微信模板</el-button>
                    <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增模板</el-button>
                </div>
            </div>

            <el-table :data="list" border stripe v-loading="loading" style="width: 100%">
                <el-table-column type="index" label="序号" width="70" align="center"/>
                <el-table-column prop="templateName" label="模板名称" show-overflow-tooltip/>
                <el-table-column prop="templateId" label="模板ID" show-overflow-tooltip/>
                <el-table-column prop="sceneCode" label="场景编码" width="120" align="center">
                    <template slot-scope="scope">
                        <el-tag size="small">{{ scope.row.sceneCode || '未配置' }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="primaryIndustry" label="主营行业" width="120" show-overflow-tooltip/>
                <el-table-column prop="deputyIndustry" label="副营行业" width="120" show-overflow-tooltip/>
                <el-table-column label="状态" width="90" align="center">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row._active" @change="(v) => handleToggle(scope.row, v)"
                            active-color="#13ce66" inactive-color="#ff4949">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="160" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button type="text" icon="el-icon-delete" style="color: #f56c6c"
                            @click="handleDelete(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="550px" :close-on-click-modal="false">
            <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
                <el-form-item label="模板名称" prop="templateName">
                    <el-input v-model="form.templateName" placeholder="如：到课通知" :disabled="isEdit"></el-input>
                </el-form-item>
                <el-form-item label="模板ID" prop="templateId">
                    <el-input v-model="form.templateId" placeholder="从微信公众平台获取" :disabled="isEdit"></el-input>
                </el-form-item>
                <el-form-item label="场景编码" prop="sceneCode">
                    <el-select v-model="form.sceneCode" placeholder="选择场景" style="width: 100%">
                        <el-option label="签到通知" value="SIGN_IN"></el-option>
                        <el-option label="请假通知" value="LEAVE"></el-option>
                        <el-option label="作业提醒" value="HOMEWORK"></el-option>
                        <el-option label="课时变动" value="SIGN_IN"></el-option>
                        <el-option label="其他" value="OTHER"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="模板内容">
                    <el-input v-model="form.templateContent" type="textarea" :rows="5"
                        :placeholder="placeholderTip" :disabled="isEdit"></el-input>
                </el-form-item>
                <el-form-item label="字段映射">
                    <div class="field-mapping-tip">
                        为模板中每个 <code v-text="kwPlaceholder"></code> 指定取值：可从下拉选择变量（如「学生姓名」），也可直接输入固定文本（如「可可教育」）。
                    </div>
                    <div class="field-mapping-actions">
                        <el-button size="mini" icon="el-icon-magic-stick" @click="parseKeywords">从模板内容解析关键字</el-button>
                        <el-button size="mini" icon="el-icon-plus" @click="addMappingRow">添加字段</el-button>
                    </div>
                    <div v-for="(m, idx) in fieldMappings" :key="idx" class="field-mapping-row">
                        <el-input v-model="m.keyword" placeholder="模板关键字，如 thing15" style="width: 160px"></el-input>
                        <span class="field-mapping-arrow">→</span>
                        <el-select v-model="m.value" filterable allow-create default-first-option
                            placeholder="选择变量或输入固定值" style="flex: 1">
                            <el-option v-for="v in sceneVarList" :key="v.key"
                                :label="v.label + '（${' + v.key + '}）'" :value="'${' + v.key + '}'"></el-option>
                        </el-select>
                        <el-button type="text" icon="el-icon-delete" style="color: #f56c6c; margin-left: 8px"
                            @click="fieldMappings.splice(idx, 1)"></el-button>
                    </div>
                    <div v-if="fieldMappings.length === 0" class="field-mapping-empty">
                        暂无映射，点击上方按钮解析模板内容或手动添加
                    </div>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="form.remark" placeholder="备注信息"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import wechatTemplateApi from '@/api/education/wechat-template'

export default {
    name: 'WechatTemplate',
    data() {
        return {
            list: [],
            loading: false,
            syncLoading: false,
            dialogVisible: false,
            dialogTitle: '新增模板',
            submitLoading: false,
            isEdit: false,
            form: {
                id: null, templateName: '', templateId: '', sceneCode: 'SIGN_IN',
                templateContent: '', primaryIndustry: '', deputyIndustry: '', remark: '', status: '0',
                fieldMapping: ''
            },
            // 字段映射编辑数组 [{ keyword, value }]
            fieldMappings: [],
            // 当前场景可用变量 [{ key, label }]
            sceneVarList: [],
            placeholderTip: '模板内容描述，如：机构名称:{{thing15.DATA}}',
            kwPlaceholder: '{{关键字}}',
            rules: {
                templateName: [{ required: true, message: '请输入模板名称', trigger: 'blur' }],
                templateId: [{ required: true, message: '请输入模板ID', trigger: 'blur' }]
            }
        }
    },
    watch: {
        'form.sceneCode'(val) {
            this.loadSceneVariables(val)
        }
    },
    mounted() {
        this.fetchList()
    },
    methods: {
        // 加载指定场景的可用变量
        async loadSceneVariables(sceneCode) {
            if (!sceneCode) {
                this.sceneVarList = []
                return
            }
            try {
                const res = await wechatTemplateApi.sceneVariables(sceneCode)
                this.sceneVarList = res.data || res || []
            } catch (e) {
                this.sceneVarList = []
            }
        },
        // 从模板内容解析 {{keyword.DATA}} 关键字，自动补充映射行
        parseKeywords() {
            const content = this.form.templateContent || ''
            const reg = /\{\{\s*(\w+)\.DATA\s*\}\}/g
            const keywords = []
            let match
            while ((match = reg.exec(content)) !== null) {
                if (!keywords.includes(match[1])) keywords.push(match[1])
            }
            if (keywords.length === 0) {
                this.$message.warning('未在模板内容中解析到 {{关键字.DATA}}')
                return
            }
            const existMap = {}
            this.fieldMappings.forEach(m => { existMap[m.keyword] = m.value })
            this.fieldMappings = keywords.map(k => ({ keyword: k, value: existMap[k] || '' }))
            this.$message.success('已解析 ' + keywords.length + ' 个关键字')
        },
        addMappingRow() {
            this.fieldMappings.push({ keyword: '', value: '' })
        },
        // fieldMapping JSON 字符串 -> 编辑数组
        parseFieldMapping(json) {
            if (!json) return []
            try {
                const obj = typeof json === 'string' ? JSON.parse(json) : json
                return Object.keys(obj).map(k => ({ keyword: k, value: obj[k] }))
            } catch (e) {
                return []
            }
        },
        // 编辑数组 -> fieldMapping JSON 字符串
        buildFieldMapping() {
            const obj = {}
            this.fieldMappings.forEach(m => {
                if (m.keyword && m.keyword.trim()) obj[m.keyword.trim()] = m.value || ''
            })
            return Object.keys(obj).length ? JSON.stringify(obj) : ''
        },
        async fetchList() {
            this.loading = true
            try {
                const res = await wechatTemplateApi.pageQuery()
                // request拦截器已解包Result，res直接是Page对象 { records, total }
                const data = res.records || res.data?.records || res.rows || []
                this.list = data.map(item => ({
                    ...item,
                    _active: item.status === '0'
                }))
            } catch (e) {
                console.error('加载模板列表失败', e)
            } finally {
                this.loading = false
            }
        },
        handleAdd() {
            this.dialogTitle = '新增模板'
            this.isEdit = false
            this.form = { id: null, templateName: '', templateId: '', sceneCode: 'SIGN_IN',
                templateContent: '', primaryIndustry: '', deputyIndustry: '', remark: '', status: '0',
                fieldMapping: '' }
            this.fieldMappings = []
            this.loadSceneVariables(this.form.sceneCode)
            this.dialogVisible = true
            this.$nextTick(() => { if (this.$refs.form) this.$refs.form.clearValidate() })
        },
        handleEdit(row) {
            this.dialogTitle = '编辑模板'
            this.isEdit = true
            this.form = { ...row }
            this.fieldMappings = this.parseFieldMapping(row.fieldMapping)
            this.loadSceneVariables(this.form.sceneCode)
            this.dialogVisible = true
            this.$nextTick(() => { if (this.$refs.form) this.$refs.form.clearValidate() })
        },
        async handleSubmit() {
            try {
                await this.$refs.form.validate()
            } catch { return }

            this.form.fieldMapping = this.buildFieldMapping()

            this.submitLoading = true
            try {
                if (this.isEdit) {
                    await wechatTemplateApi.update(this.form)
                } else {
                    await wechatTemplateApi.insert(this.form)
                }
                this.$message.success(this.isEdit ? '修改成功' : '新增成功')
                this.dialogVisible = false
                this.fetchList()
            } catch (e) {
                console.error('保存失败', e)
                this.$message.error('保存失败')
            } finally {
                this.submitLoading = false
            }
        },
        handleDelete(row) {
            this.$confirm('确认删除该模板配置吗？', '删除确认', { type: 'warning' })
                .then(async () => {
                    await wechatTemplateApi.remove(row.id)
                    this.$message.success('删除成功')
                    this.fetchList()
                }).catch(() => {})
        },
        async handleToggle(row, active) {
            const status = active ? '0' : '1'
            try {
                await wechatTemplateApi.toggleStatus(row.id, status)
                this.$message.success(active ? '已启用' : '已停用')
            } catch (e) {
                row._active = !active
                this.$message.error('操作失败')
            }
        },
        async handleSync() {
            this.syncLoading = true
            try {
                const res = await wechatTemplateApi.sync()
                this.$message.success('同步完成，新增 ' + (res.data || 0) + ' 条模板')
                this.fetchList()
            } catch (e) {
                console.error('同步失败', e)
                this.$message.error('同步失败')
            } finally {
                this.syncLoading = false
            }
        }
    }
}
</script>

<style scoped>
.wechat-template-page {
    padding: 16px;
}
.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.card-header-left {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 600;
}
.field-mapping-tip {
    font-size: 12px;
    color: #909399;
    line-height: 1.5;
    margin-bottom: 8px;
}
.field-mapping-tip code {
    background: #f5f7fa;
    padding: 1px 4px;
    border-radius: 3px;
    color: #e6a23c;
}
.field-mapping-actions {
    margin-bottom: 8px;
}
.field-mapping-row {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
}
.field-mapping-arrow {
    margin: 0 8px;
    color: #909399;
}
.field-mapping-empty {
    font-size: 12px;
    color: #c0c4cc;
    padding: 8px 0;
}
</style>
